// extracted by mini-css-extract-plugin
export default {"imageWrapper":"VF-z","hovered":"WF-z","hoverImage":"XF-z","mainImage":"YF-z","imageNoBackground":"ZF-z","fullSizeImage":"_F-z"};